import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { BaseComponent } from "@ex/module/core/domain/base-component";
import { CDKPortalComponent, DATA_TOKEN } from "@ex/module/shared/Theme/services/zen-cdk.service";



@Component({
  selector: 'app-pdf-chart-exporter',
  templateUrl: './pdf-chart-exporter.component.html',
  styleUrls: ['./pdf-chart-exporter.component.scss'],
  standalone: false
})
export class PdfChartExporterComponent extends BaseComponent implements OnInit, CDKPortalComponent {
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() results: EventEmitter<any> = new EventEmitter();


 title: any;
  date: Date = new Date();
  language: string = 'EN';

  constructor(@Inject(DATA_TOKEN) private data: any) {
    super();

  }
  ngOnInit() {
    this.language = this.data.language;
    this.title = this.data.title;
    //console.log('title', this.title)
  }
  exportChart() {
    let element = document.getElementById('single-chart-export') as HTMLElement;

    var mywindow: any = window.open('', ' ', 'left=0,top=0,width=950,height=600,toolbar=0,scrollbars=0,status=0,addressbar=0');
    const agent = window.navigator.userAgent.toLowerCase();

    mywindow.document.write(document.head.innerHTML);
    mywindow.document.write(`<body dir='${document.body.dir}' style='background-color:white'>`);
    mywindow.document.write(element.innerHTML);  // Use the cloned element's innerHTML
    mywindow.document.write('</body>');
    mywindow.document.close();
    mywindow.document.title = this.title;

    // Handle print logic for Chrome and other browsers
    if (agent.indexOf('chrome') > -1) {
      mywindow.onload = function () {
        mywindow.focus();
        setTimeout(() => {
          mywindow.print();
          mywindow.close();
        }, 2000);
      };
    } else {
      setTimeout(() => {
        mywindow.focus();
        mywindow.print();
        mywindow.close();
      }, 2000);
    }

    this.results.emit({});
  }



}
